import React from "react"
import PropTypes from "prop-types"
import ScrollIntoView from "react-scroll-into-view"

import {
  Backdrop,
  Section,
  MilestonesLabel,
  HorizontalTrack,
  TrackLine,
  TimelineNode,
  NodeDate,
  NodeDot,
  NodeLabel,
  StatsEyebrow,
  StatsRow,
  StatCard,
  StatNumber,
  StatLabel,
  NextButtonRow,
  NextButton,
} from "./styles"

import SectionTitle from "../../UI/SectionTitle"

const STATS = [
  { number: "12", label: "people" },
  { number: "10", label: "PhDs" },
  { number: "6", label: "nationalities" },
]

const formatDate = dateStr => {
  const d = new Date(dateStr)
  if (isNaN(d)) return dateStr
  return d.toLocaleDateString("en-GB", { month: "short", year: "numeric" })
}

const Timeline = ({ data }) => {
  const items = data.items
  const length = items.length

  return (
    <Backdrop id="timeline">
      <Section>
        <SectionTitle light>Our journey</SectionTitle>

        <MilestonesLabel>Milestones</MilestonesLabel>

        <HorizontalTrack style={{ "--count": length }}>
          <TrackLine />
          {items.map((item, i) => {
            const isLast = i === length - 1
            return (
              <TimelineNode key={`timeline-${i}`}>
                <NodeDate>{formatDate(item.timeline_item_date)}</NodeDate>
                <NodeDot last={isLast} />
                <NodeLabel last={isLast}>
                  {item.timeline_item_text && item.timeline_item_text.text}
                </NodeLabel>
              </TimelineNode>
            )
          })}
        </HorizontalTrack>

        <StatsEyebrow>Team Stats</StatsEyebrow>

        <StatsRow>
          {STATS.map(stat => (
            <StatCard key={stat.label}>
              <StatNumber>{stat.number}</StatNumber>
              <StatLabel>{stat.label}</StatLabel>
            </StatCard>
          ))}
        </StatsRow>

        <NextButtonRow>
          <ScrollIntoView selector="#news">
            <NextButton>
              News
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 5v14M5 12l7 7 7-7" />
              </svg>
            </NextButton>
          </ScrollIntoView>
        </NextButtonRow>
      </Section>
    </Backdrop>
  )
}

Timeline.propTypes = {
  data: PropTypes.object,
}

export default Timeline
